export default "__VITE_ASSET__Bg2BzmF1__"